import { FaWineBottle, FaWineGlassAlt } from "react-icons/fa";
import defaultImage from '../../../../utils/DefaultImage';
import { toast } from 'react-toastify';

const MasterWineListEdit = (props) => {

  const {
    wineData,
    selectedWine,
    setSelectedWine,
  } = props;

  const handleWineSelection = (wine) => {
    if (!wine?.meta || wine?.meta?.length === 0) {
      toast.warning("Wine metadata is missing. Cannot select this item.", {
        theme: 'colored',
        autoClose: 1000,
      });
      return;
    }
    setSelectedWine((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.wine_stock_id === wine.id);

      if (isAlreadySelected) {
        return prevSelected.filter((item) => item.wine_stock_id !== wine.id);
      } else {
        return [
          ...prevSelected,
          {
            wine_stock_id: wine?.id,
            is_wine_from: "all-wines",
            price: wine?.meta?.[0]?.b2b_price || "0.00",
            glass_price: wine?.meta?.[0]?.glass_price || "0.00",
            bottle_price: wine?.meta?.[0]?.served_price || "0.00",
            quantity: wine?.quantity || 1,
            is_show_bottle_price: true,
            is_show_glass_price: true,
          },
        ];
      }
    });
  };

  const handlePriceChange = (wineId, field, value) => {
    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    setSelectedWine((prevSelected) =>
      prevSelected.map((item) =>
        item.wine_stock_id === wineId ? { ...item, [field]: value } : item
      )
    );
  };


  const handleBottleGlassSelection = (wine, type) => {
    setSelectedWine((prevSelected) =>
      prevSelected.map((item) =>
        item.wine_stock_id === wine.id
          ? {
            ...item,
            is_show_bottle_price: type === "bottle" ? !item.is_show_bottle_price : item.is_show_bottle_price,
            is_show_glass_price: type === "glass" ? !item.is_show_glass_price : item.is_show_glass_price,
          }
          : item
      )
    );
  };

  // console.log(selectedWine, "all wines")

  return (
    <>
      <tbody>
        {wineData && wineData.length > 0 ? (
          wineData.map((wine, index) => (
            <tr key={index} className="border-b border-[#8B2433]/12">
              <td>
                <input
                  type="checkbox"
                  className="accent-[#8B2433] rounded-md p-2 w-14 h-4 cursor-pointer"
                  checked={selectedWine.some((item) => item.wine_stock_id === wine.id)}
                  onChange={() => handleWineSelection(wine)}
                />
              </td>

              <td className="pr-2 py-4">
                <div className="thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                  <img
                    className="w-100 p-1 h-100 object-contain border border-[#68172394] rounded-lg"
                    src={wine?.image && wine?.image !== "" ? wine?.image : defaultImage}
                    height={50}
                    width={50}
                  />
                </div>
              </td>

              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{wine?.name || 'N/A'}</td>
              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{wine?.product_type || 'N/A'}</td>
              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{wine?.nation || 'N/A'}</td>

              {/* Paid Price */}
              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                <input
                  type="text"
                  name="price"
                  className="border-[3px] px-2 py-1 w-[75%] border-[#303030] rounded-xl"
                  value={wine?.meta?.[0]?.b2b_price || "0.00"}
                  readOnly
                  style={{ cursor: "not-allowed" }}
                // value={
                //   selectedWine.find((item) => item.wine_stock_id === wine.id)?.price
                //   ?? wine?.b2b_price
                //   ?? ""
                // }
                // onChange={(e) => handlePriceChange(wine.id, "price", e.target.value)}
                />
              </td>

              {/* Glass Price */}
              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                <input
                  type="text"
                  name="glass_price"
                  // className="border-[3px] px-2 py-1 w-[75%] border-[#303030] rounded-xl"
                  className={`border-[3px] px-2 py-1 w-[75%]  rounded-xl
                    ${!wine?.meta || wine?.meta?.length === 0 ? "cursor-not-allowed bg-gray" : "border-[#303030]"}`}
                  value={
                    selectedWine.find((item) => item.wine_stock_id === wine.id)?.glass_price
                    ?? wine?.meta?.[0]?.glass_price
                    ?? ""
                  }
                  onChange={(e) => handlePriceChange(wine.id, "glass_price", e.target.value)}
                  disabled={!wine?.meta || wine?.meta?.length === 0}
                />
              </td>

              {/* Bottle Price */}
              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                <input
                  type="text"
                  name="bottle_price"
                  // className="border-[3px] px-2 py-1 w-[75%] border-[#303030] rounded-xl"
                  className={`border-[3px] px-2 py-1 w-[75%]  rounded-xl
                    ${!wine?.meta || wine?.meta?.length === 0 ? "cursor-not-allowed bg-gray" : "border-[#303030]"}`}
                  value={
                    selectedWine?.find((item) => item?.wine_stock_id === wine?.id)?.bottle_price
                    ?? wine?.meta?.[0]?.served_price
                    ?? ""
                  }
                  onChange={(e) => handlePriceChange(wine?.id, "bottle_price", e.target.value)}
                  disabled={!wine?.meta || wine?.meta?.length === 0}
                />
              </td>

              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                <div className="flex flex-col gap-4">
                  {/* Bottle Selection */}
                  <div className="flex gap-3 items-center justify-start">
                    <FaWineBottle className="w-4 h-4" color="#303030" />
                    <input
                      type="checkbox"
                      className="accent-[#8B2433] w-4 h-4 rounded-md"
                      checked={selectedWine?.find((item) => item?.wine_stock_id === wine?.id)?.is_show_bottle_price || false}
                      onChange={() => handleBottleGlassSelection(wine, "bottle")}
                      disabled={!wine?.meta || wine?.meta?.length === 0}
                    />
                  </div>

                  {/* Glass Selection */}
                  <div className="flex gap-3 items-center justify-start">
                    <FaWineGlassAlt className="w-4 h-4" color="#303030" />
                    <input
                      type="checkbox"
                      className="accent-[#8B2433] w-4 h-4 rounded-md"
                      checked={selectedWine?.find((item) => item?.wine_stock_id === wine?.id)?.is_show_glass_price || false}
                      onChange={() => handleBottleGlassSelection(wine, "glass")}
                      disabled={!wine?.meta || wine?.meta?.length === 0}
                    />
                  </div>
                </div>
              </td>

              <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                  {/* {wine?.bottles_quantity || "-"} */}
                  -
                </span>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={9} className="text-center py-4">Nessun vino trovato</td>
          </tr>
        )}
      </tbody>
    </>

  )
}

export default MasterWineListEdit;
